import { render } from "./PointsLabel.vue?vue&type=template&id=8ac33b3a&scoped=true&ts=true"
import script from "./PointsLabel.vue?vue&type=script&lang=ts"
export * from "./PointsLabel.vue?vue&type=script&lang=ts"

import "./PointsLabel.vue?vue&type=style&index=0&id=8ac33b3a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac33b3a"]])

export default __exports__